import type { CanDeactivateFn } from '@angular/router';
import type { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate(): Observable<boolean> | boolean;
}

// Genérico: cualquier formulario largo (rule-set-form, form-config-form, ...) puede implementar
// CanComponentDeactivate para pedir confirmación antes de descartar cambios sin guardar
// (auditoría UX 2026-07-06: un click accidental en el sidebar o "Volver" perdía todo el trabajo
// sin ningún aviso).
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) =>
  component.canDeactivate();
